module.exports = __webpack_public_path__ + "static/img/info.8ba3280c.png";